var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('qrcode-vue',{attrs:{"value":_vm.value,"size":_vm.size,"level":"L"}})
}
var staticRenderFns = []

export { render, staticRenderFns }